/**
 * Represents the state of an API request.
 * Can be used to track error and success states.
 */
export interface StatefulRequest {
   isInProgress: boolean;
   hasFailed: boolean;
   hasSucceeded: boolean;
   errorMessage?: string;
}

/**
 * A typed version of the @{StatefulRequest} that also supports
 * a result of the specified type.
 */
export interface TypedStatefulRequest<T> extends StatefulRequest {
   result: T;
}

/**
 * Creates an empty default instance of the @{StatefulRequest}
 */
export function createEmptyStatefulRequest(): StatefulRequest {
   return {
      isInProgress: false,
      hasFailed: false,
      hasSucceeded: false
   };
}
